import React, { useState, useEffect } from 'react';

export type TDocumentInput = File | Blob | { url: string; content?: string } | null;

export const DocumentPreview: React.FC<{ selectedDocument: TDocumentInput }> = ({ selectedDocument }) => {
    const [previewUrl, setPreviewUrl] = useState<string>('');

    useEffect(() => {
        if (!selectedDocument) {
            setPreviewUrl('');
            return;
        }

        if (selectedDocument instanceof Blob) {
            const url = URL.createObjectURL(selectedDocument);
            setPreviewUrl(url);
            return () => {
                URL.revokeObjectURL(url);
            };
        } else if (selectedDocument?.url) {
            setPreviewUrl(selectedDocument.url);
        } else {
            setPreviewUrl('');
        }
    }, [selectedDocument]);

    if (!selectedDocument) return <p className="text-sm text-slate-500 text-center py-4">No document selected</p>;

    let fileExtension = '';
    if (selectedDocument instanceof File) {
        fileExtension = selectedDocument.name.split('.').pop()?.toLowerCase() || '';
    } else if (selectedDocument instanceof Blob) {
        fileExtension = selectedDocument.type.split('/').pop()?.toLowerCase() || '';
    } else if (selectedDocument?.url) {
        fileExtension = selectedDocument.url.split('.').pop()?.toLowerCase() || '';
    }

    if (!previewUrl && fileExtension !== 'txt') {
        return <p className="text-sm text-slate-500 text-center py-4">Loading preview...</p>;
    }

    switch (fileExtension) {
        case 'jpg':
        case 'webp':
        case 'svg':
        case 'jpeg':
        case 'png':
        case 'gif':
            return <img src={previewUrl} alt="Document Preview" className="max-w-full h-auto object-contain mx-auto rounded border border-slate-100" />;
        case 'pdf':
            return (
                <iframe
                    loading="lazy"
                    src={`${previewUrl}#toolbar=1`}
                    width="100%"
                    height="600px"
                    title="Document Preview"
                    className="rounded border border-slate-200 w-full h-[75vh]"
                ></iframe>
            );
        case 'txt':
            const txtContent = (selectedDocument && 'content' in selectedDocument) ? (selectedDocument as any).content : '';
            return (
                <textarea
                    readOnly
                    value={txtContent || ''}
                    className="w-full h-[500px] p-3 border border-slate-200 rounded text-xs font-mono focus:outline-none"
                />
            );
        case 'docx':
            return (
                <div className="text-center py-4">
                    <p className="text-sm text-slate-500">DOCX preview not supported in browser directly.</p>
                </div>
            );
        default:
            return <p className="text-sm text-slate-500 text-center py-4">Unsupported file type</p>;
    }
};
